const langMapping = {
  "en": "en-US",
  "da": "da-DK",
  "de": "de-DE",
  "es": "es-ES",
  "fr": "fr-CA",
  "id": "id-ID",
  "it": "it-IT",
  "ja": "ja-JP",
  "ko": "ko-KR",
  "nb": "nb-NO",
  "nl": "nl-NL",
  "pt": "pt-BR",
  "ru": "ru-RU",
  "sv": "sv-SE",
  "th": "th-TH",
  "tr": "tr-TR",
  "vi": "vi-VN",
  "zh": "zh-TW"
}

function translateLang(language, userLanguage) {
  var locale = ""
  if (language && language.length < 3) {
    const matched = language.match(/[A-Za-z0-9]{2}/i)
    if (matched) {
      locale = langMapping[language]
    }
  } else if (userLanguage && userLanguage.length < 3) {
    const matched = userLanguage.match(/[A-Za-z0-9]{2}/i)
    if (matched && matched.length > 1) {
      locale = langMapping[userLanguage]
    }
  } else {
    locale = language || userLanguage
  }
  if (locale.length < 4) {
    locale = "en-US"
  }
  return locale
}
export default translateLang



// WEBPACK FOOTER //
// ./src/lang.js